<template>
  <div class="mit-borrowed-list">
    <MitDataTableClient
      title="Borrowed"
      :editable="false"
      :headers="headers"
      :items="borrowed"
    >
      <template v-slot:item.spacesDisplay="{ item, search }">
        <MitKeySpaces :search="search" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/>
      </template>

      <template v-slot:item.spacesDisplay-mobile="{ item, search }">
          <span>
          Spaces:<MitKeySpaces size="small" :dark="false" :search="search" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/><br/>
          </span>
      </template>
    </MitDataTableClient>
  </div>
</template>

<script>
import moment from 'moment';
import MitBorrowService from '../../services/MitBorrowService.js';
import MitDataTableClient from '../common/MitDataTableClient.vue';
import MitKeySpaces from '../keys/MitKeySpaces.vue';

export default {
  name: 'MitBorrowedList',
  components: {
    MitDataTableClient,
    MitKeySpaces
  },
  props: {
  },
  data: function() {
    return {
      search: '',
      headers:  [
          {text: 'Name',align: 'start',sortable: true,value: 'ownerId', width: '8%', mobile:true},
          {text: 'Key',sortable: true,value: 'keyName',  width: '8%', mobile:true},
          {text: 'Spaces',sortable: false,value: 'spacesDisplay'},
          {text: 'Borrowed Date',sortable: true,value: 'dates_local.checkoutDt', width: '12%', mobile:true, sort: function(a,b){
               return moment.utc(a).diff(moment.utc(b))
          }}
        ],
      borrowed:[]
    }
  },
  mounted() {
    MitBorrowService.requestGetBorrowedKeys()
      .then((data) => {
        this.borrowed = data;
      })
      .catch((error) => {
        console.log('An error occurred trying to get keys list', error);
      });
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
  .search-text {
    margin-top: -5px;
  }
  .search-type {
    max-width: 112px;
  }
</style>
